<template>
  <v-card style="background-color: #F7F7F7" elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12" class="mx-6">
        <span class="headline font-weight-bold">
          {{ roleUser.toUpperCase() }}
        </span>
        <p class="font-weight mb-0">
          {{ currentUser.nombre }}  {{ currentUser.primer_apellido }}  {{ currentUser.segundo_apellido }}
        </p>
      </v-col>
      <v-col cols="12" class="mt-0" v-if="apelacion.toca">
        <v-card class="mx-4">
          <v-toolbar dark color="#286090" class="text-uppercase">
            <v-toolbar-title>Returno del Toca</v-toolbar-title>
          </v-toolbar>
          <v-alert
            class="mt-3"
            border="top"
            color="red"
            dark
            outlined
            type="info"
          >
            <b>ATENCIÓN:</b> Los datos mostrados, corresponden a la última Apelacion registrada el dia
            <b>{{ apelacion.toca.last_apelacion.fecha_recepcion | formatDateTime }}</b>
          </v-alert>
          <v-divider></v-divider>
          <div class="text-center" style="background-color: #CDA548; color: white;">
            <v-toolbar-title><b>Toca: {{ apelacion.numero_completo}}</b></v-toolbar-title>
          </div>
          <v-divider></v-divider>
          <TableDetallesApelacion :apelacion="apelacion.toca.last_apelacion" />
        </v-card>
      </v-col>
    </v-row>
    <!-- FORM FECHAS -->
    <v-card class="mx-4 mt-3">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-toolbar color="grey" dark dense>
          <v-toolbar-title class="text-uppercase">
            Ingrese las fechas para Turnar Nuevamente
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              class="mt-n4"
            >
              <v-menu
                v-model="menu_fecha_citacion"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_citacion"
                    label="Fecha de Citación"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :rules="[rules.required]"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_citacion"
                  @input="menu_fecha_citacion = false"
                  locale="es-mx"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-n4"
            >
              <v-menu
                v-model="menu_fecha_turno"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_turno"
                    label="Fecha de Turno"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :rules="[rules.required]"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_turno"
                  @input="menu_fecha_turno = false"
                  locale="es-mx"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-n4">
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="red"
            @click="$router.push({ name:'SecAcuerdosIndex' })"
            :disabled="loading"
          >
            cancelar
          </v-btn>
          <v-btn
            dark
            color="success"
            @click="validate"
            :disabled="loading"
          >
            returnar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <br>
  </v-card>
</template>

<script>
  import TableDetallesApelacion from "@/components/TableDetallesApelacion";
  import { mapGetters } from "vuex";

  export default {
    components: {
      TableDetallesApelacion
    },
    data: () => ({
      apelacion:{},
      dialog:false,
      dialogFechas:false,
      valid: false,
      loading: false,
      menu_fecha_citacion: false,
      menu_fecha_turno: false,
      fecha_citacion: "",
      fecha_turno: "",
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    computed: {
      ...mapGetters(["roleUser", "currentUser"])
    },
    created() {
      this.apelacion_id =  JSON.parse(localStorage.getItem("currentApelacion"))
      this.getApelacion(this.apelacion_id);
    },
    methods:{
      getApelacion(id){
        this.$store.dispatch("SHOW_APELACION", { url: "/apelacion/" + id }).then(response => {
          this.apelacion = response.data.data.apelacion
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.dialogFechas=false
          this.loading = true;
          this.save();
        }
      },
      save(){
        this.$store.dispatch("UPDATE_CUENTA", { url: "/apelacion/" + this.apelacion.id + "/returnar",
          data:{
            fecha_citacion: this.fecha_citacion,
            fecha_turno: this.fecha_turno
          }
        }).then(response => {
          if (response.status == 200) {
            this.$swal({
              title: "Éxito",
              text: "Apelación returnada correctamente!!!",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.$router.push('/secacuerdos' )
            this.dialog = false
          }
        })
        .catch(error => {
          console.log(error);
        });
      }
    }
  };
</script>
